import { FallbackImage } from "@/components/fallback-img";
import { GlassSelect, GlassSelectContent, GlassSelectItem, GlassSelectTrigger, GlassSelectValue } from "@/components/glass-select";
import { GlassButton } from "@/components/ui/glass-button";
import { GlassTabsList, GlassTabsTrigger } from "@/components/ui/glass-tabs";
import { GlassTooltip, GlassTooltipContent, GlassTooltipTrigger } from "@/components/ui/glass-tooltip";
import { admin } from "../../config/companies";
import type { CompanyData } from "../../config/companies/types";
import { ArrowUpDown, Building2 } from "lucide-react";

export function CompanyHeader({ metadata }: { metadata?: CompanyData }) {
  return (
    <div className="fixed top-0 right-0 left-0 flex justify-between z-50 mx-1">
      <div className="flex justify-end items-center my-1 w-32">
        <GlassTooltip>
          <GlassTooltipTrigger asChild>
              <a href={admin.website} target="_blank" rel="noopener noreferrer">
                <GlassButton className="my-1 mr-1 px-1" asChild size="lg" variant="primary">
                  Zenitova
                </GlassButton>
              </a>
          </GlassTooltipTrigger>
          <GlassTooltipContent>
            <p>{admin.title}</p>
          </GlassTooltipContent>
        </GlassTooltip>
        
        <GlassTooltip>
          <GlassTooltipTrigger asChild>
            <a href={metadata?.website} target="_blank" rel="noopener noreferrer">
              <GlassButton className="my-1" asChild size="iconlg" variant="primary">
                <FallbackImage src={`${window.location.href}/logo.png`} fallback={
                  <span>{(metadata?.title || "").trim().slice(0,1)}</span>
                } />
              </GlassButton>
            </a>
          </GlassTooltipTrigger>
          <GlassTooltipContent>
            <p>{metadata?.title}</p>
          </GlassTooltipContent>
        </GlassTooltip>
      </div>

      <GlassTabsList className="my-2">
          <GlassTabsTrigger value="timeline" className="group">
            <GlassTooltip>
              <GlassTooltipTrigger asChild>
                  <ArrowUpDown />
              </GlassTooltipTrigger>
              <GlassTooltipContent>
                {/* <p>Show timeline <br /> (Bills and Transfers) </p> */}
                <p>Zaman akışını göster <br /> (Fatura ve Transferler) </p>
              </GlassTooltipContent>
            </GlassTooltip>
          </GlassTabsTrigger>
        <GlassTabsTrigger value="profile" className="group">
          <GlassTooltip>
            <GlassTooltipTrigger asChild>
                <Building2 />
            </GlassTooltipTrigger>
            <GlassTooltipContent>
              {/* <p>Show company information <br /> (Company/Bank info and Deals) </p> */}
              <p>Şirket bilgilerini göster <br /> (Şirket/Banka bilgisi ve Anlaşmalar) </p>
            </GlassTooltipContent>
          </GlassTooltip>
        </GlassTabsTrigger>
      </GlassTabsList>

      <div className="flex justify-start items-center my-1 w-32">
        <GlassSelect defaultValue="tr">
          <GlassSelectTrigger className="my-1 mr-1" noArrow>
            <GlassSelectValue />
          </GlassSelectTrigger>
          <GlassSelectContent>
            <GlassSelectItem value="en">UTC</GlassSelectItem>
            <GlassSelectItem value="tr">GMT+3</GlassSelectItem>
          </GlassSelectContent>
        </GlassSelect>
        <GlassSelect defaultValue="tr">
          <GlassSelectTrigger className="my-1" noArrow>
            <GlassSelectValue />
          </GlassSelectTrigger>
          <GlassSelectContent>
            <GlassSelectItem value="en">English</GlassSelectItem>
            <GlassSelectItem value="tr">Türkçe</GlassSelectItem>
          </GlassSelectContent>
        </GlassSelect>
      </div>
      {/* {JSON.stringify(metadata, null, 2) || "Company metadata not found."} */}
    </div>
  )
};